import React, { useState } from "react"
import SyntaxHighlighter from 'react-syntax-highlighter'
import { vs2015 } from 'react-syntax-highlighter/dist/esm/styles/hljs'

const CodeBlock = ({
    code,
    title,
    exampleLanguages,
    selectedLanguage,
    handleLanguageSelect,
    hasLanguageSelector = true,
    hasCopyCodeButton = true,
    hasMultipleLanguages = false,
    clipBoardButtonSize = 20,
    showLineNumbers = true
}) => {

    return (
        <div className="home-code-example-box">
            <div className="box-body">
                <SyntaxHighlighter language={'json'} showLineNumbers={showLineNumbers} wrapLines={true} style={vs2015}>
                    {code}
                </SyntaxHighlighter>
            </div>
        </div>
    )
}

export default CodeBlock
